import React, { useMemo } from "react";

const Snow = ({ count = 40 }) => {
  const flakes = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const drift = (Math.random() * 14 - 7) + "vw";
      const size = 8 + Math.random() * 18;
      const duration = 14 + Math.random() * 18;
      const delay = -Math.random() * 25;
      const opacity = 0.35 + Math.random() * 0.6;
      const chars = ["\u2744", "\u2745", "\u2746", "\u00b7"];
      const char = chars[Math.floor(Math.random() * chars.length)];
      return { i, left, drift, size, duration, delay, opacity, char };
    });
  }, [count]);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ zIndex: 2 }}
    >
      {flakes.map((f) => (
        <span
          key={f.i}
          className="snow-flake"
          style={{
            left: `${f.left}%`,
            fontSize: `${f.size}px`,
            opacity: f.opacity,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            // CSS vars used by keyframes
            "--x-start": "0px",
            "--x-end": f.drift,
          }}
        >
          {f.char}
        </span>
      ))}
    </div>
  );
};

export default Snow;
